import React, { useState, useRef, useContext } from "react";
import PropTypes from "prop-types";
import CredentialsViewContainer from "./CredentialsViewContainer_v2";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import Switch from "@mui/material/Switch";
import CustomAlert from "./CustomAlert";
import "./styles/CredentialsPage.css";

function CredentialsPage(props) {
  const creds = useContext(CredsContext).creds;
  const [loginDisabled, setLoginDisabled] = useState(
    localStorage.getItem("instanceInfo") == null,
  );
  const [openAlert, setOpenAlert] = useState(false);
  const errorMessage = useRef();

  const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      handleClick();
    }
  };

  const handleClick = () => {
    if (creds.company && creds.instanceType) {
      props.waitHandler(true);
      const keyValue = creds.company + "|" + creds.instanceType;
      const keyObject = {
        "company|instance": keyValue,
      };

      Tools.dbRead("collabCenterCustomers", keyObject).then((dbObj) => {
        try {
          const adminCreds = {
            instanceType: dbObj.instanceType,
            company: dbObj.company,
            username: dbObj.username,
            password: dbObj.password,
            deletionType: "Simple",
            userType: "Admin",
            id: dbObj.userid,
          };

          localStorage.setItem(
            "adminCreds",
            Tools.encrypt(JSON.stringify(adminCreds)),
          );

          const authString = Tools.getXmlBodyAuthString(adminCreds);
          const urlString = Tools.getInstanceUrl(adminCreds);
          const checkLoginString =
            authString +
            '<Read type="User" method="equal to" limit="1"><User><id>' +
            adminCreds.id +
            "</id></User></Read></request>";
          Tools.fetchPost(checkLoginString, urlString).then((validLogin) => {
            if (validLogin.authStatus != "401") {
              props.prepPage(adminCreds);
            } else {
              errorMessage.current = "Invalid Login.  Please try again.";
              setOpenAlert(true);
              props.waitHandler(false);
            }
          });
        } catch (e) {
          errorMessage.current =
            "A " +
            creds.instanceType +
            " instance for company '" +
            creds.company +
            "' could not be found.";
          setOpenAlert(true);
          props.waitHandler(false);
        }
      });
    }
  };

  const handleProductChange = (event) => {
    props.setProduct(event.target.checked);
  };

  const handleDocumentationClick = () => {
    let a = document.createElement("a");
    a.href =
      "https://collab-center-documentation.s3.amazonaws.com/GETTING+STARTED.pdf";
    a.target = "_blank";
    a.click();
  };

  return (
    <Box sx={{ width: "100vw", textAlign: "center" }}>
      <br></br>
      <br></br>
      <br></br>

      <br></br>
      <Box className="inputbox">
        <Box>
          <img src="collabcenter_horizontal_spp.png" height="80px"></img>
        </Box>
        <hr></hr>
        <br></br>
        <CredentialsViewContainer
          handleKeyPress={handleKeyPress}
          setLoginDisabled={setLoginDisabled}
          boxSize="large"
        />
        <br></br>
        <Button
          className="bluebutton"
          disabled={loginDisabled}
          onClick={handleClick}
          size="large"
        >
          Login
        </Button>
        <br></br> <br></br>
        <hr></hr>
        <Typography
          sx={{
            marginLeft: "40px",
            paddingLeft: "10px",
            textAlign: "left",
            fontFamily: "Garamond",
            fontWeight: "bold",
            fontStyle: "italic",
            fontSize: "large",
            width: "100px",
            borderRadius: "15px",
          }}
        >
          Created by
        </Typography>
        <img height="100px" src="Addolution Scribble.png" />
        <Typography
          onClick={handleDocumentationClick}
          variant="h6"
          sx={{
            paddingTop: "5px",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Getting Started Guide
        </Typography>
      </Box>
      <CustomAlert
        alertText={errorMessage.current}
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        backgroundColor="crimson"
      />
    </Box>
  );
}

export default CredentialsPage;

CredentialsPage.propTypes = {
  prepPage: PropTypes.func,
  setProduct: PropTypes.func,
  waitHandler: PropTypes.func,
  product: PropTypes.string,
};

/*
      <Box>
          
          <span style={{ fontWeight: "bold" }}>Choose Product&nbsp;&nbsp;</span>
          <br></br>
          Collaboration Companion
          <Switch
            className={
              props.product == "oada"
                ? "credsProductSwitchOn"
                : "credsProductSwitchOff"
            }
            onChange={handleProductChange}
            defaultChecked={props.product == "oada"}
            //checked={props.groupBy == "name"}
          />
          Data Assistant
        </Box>

*/
